module.exports = __webpack_public_path__ + "static/img/580a7c56.svg";